import { AvatarCoreDriver } from './AvatarCore/AvatarCore.uni.driver';

export interface AvatarUniDriver extends AvatarCoreDriver {
  clickIndication: () => Promise<void>;
  clickCustomIndication: () => Promise<void>;
  indicationExists: () => Promise<boolean>;
  isLoading: () => Promise<boolean>;
  customIndicationExists: () => Promise<boolean>;
}
